import { useForm } from 'react-hook-form'
import { usePartnerCallbackConfigurationUpdate } from 'domains/connect/api/callback-configuration/partnerCallbackConfigurationUpdate.hooks'
import { type CallbackConfigurationInput } from 'domains/connect/api'
import { useErrorNotification, useSuccessNotification } from './notifications.hooks'

export const useCallbackConfigurationForm = callbackConfiguration => {
  const { register, errors, handleSubmit, setValue } = useForm()

  const {
    updatePartnerCallbackConfiguration,
    updatedCallbackConfiguration,
    loading: updateCallbackConfigurationLoading,
    error: updateCallbackConfigurationError,
  } = usePartnerCallbackConfigurationUpdate()

  const { notifySuccess } = useSuccessNotification('connect.configuration.form.submit.success')
  useErrorNotification(updateCallbackConfigurationError, 'connect.configuration.form.submit.error')

  const onSubmit = handleSubmit(data => {
    const statusesOfInterest: string[] = []

    if (callbackConfiguration) {
      callbackConfiguration.availableStatuses.forEach((status: string) => {
        if (data[status]) {
          statusesOfInterest.push(status)
        }
      })
    }

    const formattedData: CallbackConfigurationInput = {
      id: callbackConfiguration.id,
      accessTokenTtl: parseInt(data.accessTokenTtl),
      authUri: data.authUri,
      callbackUri: data.callbackUri,
      credentialsClientId: data.clientId,
      credentialsClientSecret: data.clientSecret,
      statusesOfInterest: statusesOfInterest,
    }

    updatePartnerCallbackConfiguration({
      id: callbackConfiguration.id,
      updatedCallbackConfiguration: formattedData,
    }).then(result => {
      if (result && result.data) {
        notifySuccess()
      }
    })
  })

  return {
    onSubmit,
    errors,
    register,
    setValue,
    updatedCallbackConfiguration,
    updateCallbackConfigurationLoading,
    updateCallbackConfigurationError,
  }
}
